import { Component, Input } from '@angular/core';
import { NavController, NavParams, ModalController, LoadingController, Events, PopoverController, ActionSheetController } from 'ionic-angular';
import { AppState, patronFields } from '../../config/state';
import { ConfigProvider } from '../../providers/config/config';
import { CoLibraryCardPage } from '../../pages/co-library-card/co-library-card';
import { CoPatronFeesPage } from '../../pages/co-patron-fees/co-patron-fees';
import { IlsProvider } from '../../providers/ils/ils';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { CoLocationComponent } from '../../components/co-location/co-location';
import { LocationsProvider } from '../../providers/locations/locations';
import { LoginProvider } from '../../providers/login/login';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { CoBibItemProvider } from '../../providers/co-bib-item/co-bib-item';
import { PatronProvider } from '../../providers/patron/patron';
import { ListProvider } from '../../providers/list/list';
import moment from 'moment';
import { CoEmailInputComponent } from '../co-email-input/co-email-input';
import { CoPatronDetailFormPage } from '../../pages/co-patron-detail-form/co-patron-detail-form';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { MailProvider } from '../../providers/mail/mail';
import { DigitalItemsProvider } from '../../providers/digital-items/digital-items';
import { EventsProvider } from '../../providers/events/events';
import { from } from 'rxjs/observable/from';
import { PatronFieldsProvider } from '../../providers/patronFields/patronFields.service';
/**
 * Generated class for the CoPatronDetailComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-patron-detail',
  templateUrl: 'co-patron-detail.html',
  providers: [
    PatronFieldsProvider
  ]
})
export class CoPatronDetailComponent {
  @Input() patron: any;
  @Input('selectTab') selectTab: string;
  @Input('pinlessOverride') pinlessOverride: boolean = false;
  view: any;
  clientKeyword: string;
  shelvesView: string;
  eventsView: string;
  reserveView: string;
  eventDateView: string;
  allCheckouts: any = [];
  allHolds: any = [];
  filteredCheckouts: any = [];
  filteredHolds: any = [];
  checkoutTypes: any = [];
  holdsTypes: any = [];
  currentCheckoutType: string = "all";
  currentHoldsType: string = "all";
  loadPage: boolean = false;
  showHeader: boolean = false;
  registeredEvents = {allEvents: [], pastEvents: [], currentEvents: []};
  interestedEvents: any = [];
  interestedCurrentEvents: any = [];
  interestedPastEvents: any = [];
  currentModal: any;
  bookingsArray = {allBookings: [], pastBookings: [], currentBookings: []};
  bookingsReceived: boolean = false;
  loader: any;
  placeholderText: string = "No info";
  editMode: boolean = false;
  fees: Array<any> = [];
  totalFees: number = 0;
  addressEditMode: boolean = false;
  emailEditMode: boolean = false;
  phoneEditMode: boolean = false;
  branchEditMode: boolean = false;
  pinEditMode: boolean = false;
  nameEditMode: boolean = false;
  patronInfoChanged: boolean = false;
  feesAmountToPay: number = 0;
  feesCountToPay: number = 0;
  feesToPay: Array<any> = [];
  checkoutsLoaded: boolean = false;
  ilsCheckoutsLoaded: boolean = false;
  digitalCheckoutsLoaded: boolean = false;
  holdsLoaded: boolean = false;
  ilsHoldsLoaded: boolean = false;
  digitalHoldsLoaded: boolean = false;
  newHomeBranch: string;
  branches: Array<any>;
  previousPin: "";
  formOptions$: any;
  saving = false;
  patronFields: patronFields = {};
  private holdReady: number = 0;
  private _handler: Function;
  constructor(public navCtrl: NavController, private _patronFields: PatronFieldsProvider, public navParams: NavParams, private patronProvider: PatronProvider, private listProvider: ListProvider, public state : AppState, private config: ConfigProvider, private modalCtrl : ModalController, private ilsProvider: IlsProvider, public loading: LoadingController, private toast : ToastAlertsProvider, private locationsProvider : LocationsProvider, private loginProvider: LoginProvider, private events : Events, private timeout : TimeoutFunctionsProvider, private bib:CoBibItemProvider, private popoverCtrl: PopoverController, private actionSheetCtrl: ActionSheetController, private mail : MailProvider, private digitalProdivder : DigitalItemsProvider, private _eventsProvider: EventsProvider) {
    this.patronFields = this._patronFields.getFields();
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this._handler = (res) => {
      if (!res && this.navCtrl.canGoBack() && !this.state.staff) {
        this.navCtrl.pop();
      }
    };
    this.events.subscribe('patronLoggedIn', this._handler);
    this.events.subscribe('patronEvent',(patron: any) => {
      this.patron = patron;
    });
    let lintWindow: any = window; //lint was breaking shit
    if (lintWindow.cordova && lintWindow.cordova.plugins && lintWindow.cordova.plugins.Keyboard) {
      lintWindow.cordova.plugins.Keyboard.disableScroll(false);
    }
    window.addEventListener('native.keyboardhide', this.scrollWindow);
    this.locationsProvider.getLocations().then(res=>{
      this.branches = res.map((location) => {
        return {
          code: location.polarisId,
          name: location.name
        }
      });
    });
    this._eventsProvider.getEventTypes().then((types) => {
      let eventTypes = types.map(t => t.selected = false);
      this.state.eventColors = {
        types:eventTypes
      };
    });
    this.patronProvider.getPatronFormOptions().then((data)=>{
      this.formOptions$ = data;
    });
  }

  shouldShowAddressFields() {
    if (this.patronFields.address1
      || this.patronFields.address2
      || this.patronFields.city
      || this.patronFields.state
      || this.patronFields.zip
      ) return true
    return false;
  }
  canEditAddressFields() {
    if (this.patronFields.address1 && this.patronFields.address1.editable
      || this.patronFields.address2 && this.patronFields.address2.editable
      || this.patronFields.city && this.patronFields.city.editable
      || this.patronFields.state && this.patronFields.state.editable
      || this.patronFields.zip && this.patronFields.zip.editable
      ) return true
    return false;
  }

  shouldShowAdditionalFields() {
    if ( this.patronFields.residentCategory
      || this.patronFields.cardCampaign
      || this.patronFields.manualBlock
      || this.patronFields.patronType
      || this.patronFields.noticePreference
      || this.patronFields.user1
      || this.patronFields.user2
      || this.patronFields.user3
      || this.patronFields.user4
      || this.patronFields.user5
      ) return true;
    return false;
  }

  valueForField(value, fieldType) {
    if (this.formOptions$[fieldType]) {
      const obj = this.formOptions$[fieldType].find((x) =>  x.id == value);
      if (obj) return obj.name;
    }
    return value;
  }

  getDateFormat() {
    return this.state.internationalDate ? 'dd/MM/yyyy' : 'MM/dd/yyyy';
  }

  scrollWindow() {
    window.scroll(0, window.scrollY);
  }

  ngOnInit() {
    this.loadAccount();
    this.events.subscribe('interestedEventRemoved', () => this.getInterestedEvents() );
  }

  ngOnDestroy() {
    this.events.unsubscribe('switchedUser');
    this.events.unsubscribe('patronLoggedIn', this._handler);
    let lintWindow: any = window; //lint was breaking shit
    if (lintWindow.cordova && lintWindow.cordova.plugins && lintWindow.cordova.plugins.Keyboard) {
      lintWindow.cordova.plugins.Keyboard.disableScroll(true);
    }
    window.removeEventListener('native.keyboardhide', this.scrollWindow);
  }

  switchedUserInitialize(scope) {

  }

  presentSortList() {
    if (this.view === 'shelves') {
      if (this.shelvesView === 'checkouts') {
        let actionSheet = this.actionSheetCtrl.create({
          title: 'Sort by',
          buttons: [
            {
              text: 'Alphabetical',
              handler: () => {
                this.sortList('alphabetical')
              }
            },
            {
              text: 'Return by date',
              handler: () => {
                this.sortList('date');
              }
            },
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
                console.log('Cancel clicked');
              }
            }
          ]
        });
        actionSheet.present();
      } else if (this.shelvesView === 'holds') {
        let actionSheet = this.actionSheetCtrl.create({
          title: 'Sort by',
          buttons: [
            {
              text: 'Alphabetical',
              handler: () => {
                this.sortList('alphabetical')
              }
            },
            {
              text: 'Position in queue',
              handler: () => {
                this.sortList('queue');
              }
            },
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
                console.log('Cancel clicked');
              }
            }
          ]
        });
        actionSheet.present();
      }
    } else if (this.view === 'bookings') {
      let actionSheet = this.actionSheetCtrl.create({
        title: 'Sort by',
        buttons: [
          {
            text: 'Date',
            handler: () => {
              this.sortList('date')
            }
          },
          {
            text: 'Room',
            handler: () => {
              this.sortList('room');
            }
          },
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          }
        ]
      });
      actionSheet.present();
    }

  }

  sortList(type) {
    if (this.view === 'shelves') {
      if (this.shelvesView === 'checkouts') {
        if (type === 'alphabetical') {
          this.allCheckouts.sort((a,b) => {
            if(a.bib.title < b.bib.title) { return -1; }
            if(a.bib.title > b.bib.title) { return 1; }
            return 0;
          })
        } else if (type === 'date') {
          this.allCheckouts.sort((a,b) => {
            if(moment(a.dueDate).isSameOrBefore(b.dueDate)) { return -1; }
            if(moment(a.dueDate).isAfter(b.dueDate)) { return 1; }
            return 0;
          })
        }
      }
      else if (this.shelvesView === 'holds') {
        if (type === 'alphabetical') {
          this.allHolds.sort((a,b) => {
            if(a.bib.title < b.bib.title) { return -1; }
            if(a.bib.title > b.bib.title) { return 1; }
            return 0;
          })
        } else if (type === 'queue') {
          this.allHolds.sort((a,b) => {
            return a.position-b.position;
          })
        }
      }
    } else if (this.view === 'bookings') {
      if (this.reserveView === 'all') {
        if (type === 'date') {
          this.bookingsArray.allBookings.sort((a,b) => {
            if(moment(a.startTime).isSameOrBefore(b.startTime)) { return -1; }
            if(moment(a.startTime).isAfter(b.startTime)) { return 1; }
            return 0;
          })
        } else if (type === 'room') {
          this.bookingsArray.allBookings.sort((a,b) => {
            if(a.roomName < b.roomName) { return -1; }
            if(a.roomName > b.roomName) { return 1; }
            return 0;
          })
        }
      } else if (this.reserveView === 'current') {
        if (type === 'date') {
          this.bookingsArray.currentBookings.sort((a,b) => {
            if(moment(a.startTime).isSameOrBefore(b.startTime)) { return -1; }
            if(moment(a.startTime).isAfter(b.startTime)) { return 1; }
            return 0;
          })
        } else if (type === 'room') {
          this.bookingsArray.currentBookings.sort((a,b) => {
            if(a.roomName < b.roomName) { return -1; }
            if(a.roomName > b.roomName) { return 1; }
            return 0;
          })
        }
      } else if (this.reserveView === 'past') {
        if (type === 'date') {
          this.bookingsArray.pastBookings.sort((a,b) => {
            if(moment(a.startTime).isSameOrBefore(b.startTime)) { return -1; }
            if(moment(a.startTime).isAfter(b.startTime)) { return 1; }
            return 0;
          })
        } else if (type === 'room') {
          this.bookingsArray.pastBookings.sort((a,b) => {
            if(a.roomName < b.roomName) { return -1; }
            if(a.roomName > b.roomName) { return 1; }
            return 0;
          })
        }
      }
    }
  }

  openEmailInput(screen) {
    let popover = this.popoverCtrl.create(CoEmailInputComponent, { email: (this.patron.email ? this.patron.email : "")}, {cssClass: 'custom-email-input-popover'});
    popover.present();
    popover.onDidDismiss((email) => {
      if (email && email.info) {
        let content, params;
        if (screen === 'bookshelf'){
          let holdsList = '';
          let checkoutsList = '';
          if (this.allHolds.length >0){
            this.allHolds.forEach(hold => {
              holdsList += `Title: ${hold.bib.title} \r\n Author: ${hold.bib.author} \r\n Pickup from: ${hold.pickupLocation.name} \r\n Position: ${hold.postion} of ${hold.queueLength} \r\n \r\n `
            });
          } else {
            holdsList = "None";
          };
          if (this.allCheckouts.length > 0){
            this.allCheckouts.forEach(out => {
              checkoutsList += `Title: ${out.bib.title} \r\n Author: ${out.bib.author} Due: ${out.dueDate}\r\n \r\n`
            });
          } else {
            checkoutsList = "None";
          }
          params = {
            template: 'account_bookshelf_list_email',
            email: email.info,
            phone: ''
          };
          content = `
            first_name: "${this.patron.firstName}",
            holds_list: "${encodeURIComponent(holdsList)}",
            checkouts_list: "${encodeURIComponent(checkoutsList)}",
            library_card: "${this.patron.barcode}",
            total_holds: "${this.allHolds.length}",
            total_checkouts: "${this.allCheckouts.length}"
          `;
        } else if (screen ==='reserve'){
          let bookings = '';
          if (this.bookingsArray.currentBookings.length > 0){
            this.bookingsArray.currentBookings.forEach(bk => {
              bookings += `Room: ${bk.roomName} \r\n Date: ${moment(bk.startTime).format("MMMM DD, YYYY h:mma")}`
            })
          }
          params = {
            template: 'account_bookings_list_email',
            email: email.info,
            phone: ''
          };
          content = `
            first_name: "${this.patron.firstName}",
            bookings: "${encodeURIComponent(bookings)}",
            library_card: "${this.patron.barcode}",
            total_bookings: "${this.bookingsArray.currentBookings.length}"
          `;
        };

        this.mail.sendGeneralEmail(params, content).then(res =>{
          // console.log(res);
          if (res[0].status){
            this.toast.showAlert('', 'Email sent!', 'success', 4000);
          } else {
            this.toast.showAlert('', 'Email failed to send', 'warning', 4000);
          };
        });
      };
    });
  }

  async loadAccount() {
    if (this.patron) {
      this.initializeMyAccount(this.patron, true);
    } else {
      await this.loginProvider.requireLogin((res) =>{
        this.initializeMyAccount(res, true);
        this.events.subscribe('switchedUser', () => {
          this.loader = this.loading.create({content:'Getting account information...'});
          this.loader.present();
          this.resetMyAccount();
          this.initializeMyAccount(this.state.patron, true);
        });
      }, undefined, this.pinlessOverride);
    }

    this.view = 'account';
    this.shelvesView = 'all';
    this.eventsView = 'interested';
    this.eventDateView = 'current';
    if (this.state.staff) {
      this.eventsView = 'registered';
    }
    this.reserveView = 'current';
    this.clientKeyword = this.state.client.keyword;
  }

  successfulLogin(patronDetails, scope) {
    scope.initializeMyAccount(patronDetails, true);

  }

  resetMyAccount() {
    this.patron = undefined;
    this.registeredEvents = {allEvents: [], pastEvents: [], currentEvents: []};
    this.interestedEvents = [];
    this.allCheckouts = [];
    this.allHolds = [];
    this.filteredCheckouts = [];
    this.filteredHolds = [];
    this.bookingsArray.pastBookings = [];
    this.bookingsArray.currentBookings = [];
    this.bookingsArray.allBookings = [];
  }

  initializeMyAccount(patronDetails, fillData?) {

    if (fillData) {
      this.patron = patronDetails;
      // this.patron.address = ["325 N Michigan St","Toledo", "OH 43604"]
      if (this.patron.addressDetails){
        this.patron.street = this.patron.addressDetails.address1 + (this.patron.addressDetails.address2 ? ", " + this.patron.addressDetails.address2 : "");
        this.patron.city = this.patron.addressDetails.city;
        this.patron.state = this.patron.addressDetails.state;
        this.patron.cityState = this.patron.addressDetails.cityState;
        this.patron.zip = this.patron.addressDetails.zip;
      } else {
        if (this.patron.address && this.patron.address.length === 3) {
        this.patron.street = this.patron.address[0];
        this.patron.city = this.patron.address[1];
        this.patron.state = this.patron.address[2].split(' ')[0];
        this.patron.zip = this.patron.address[2].split(' ')[1];
      } else if (this.patron.address && this.patron.address.length === 2){
        this.patron.street = this.patron.address[0];
        this.patron.city = this.patron.address[1].split(', ')[0];
        this.patron.state = this.patron.address[1].split(' ')[1];
        this.patron.zip = this.patron.address[1].split(' ').slice(2).toString().replace(/,/g, '');
      } else {
        this.patron.street = "";
        this.patron.city = "";
        this.patron.state = "";
        this.patron.zip = "";
        this.patron.cityState = "";
      }
    }
      this.patron.phone = this.patron.phone || '';
      // this.patron.pickupBranch = this.patron.pickupLocation.name;
      try {
        this.patron.branch = this.branches.find(b => b.code === this.patron.homeBranchId).name;
        this.newHomeBranch = this.patron.homeBranchId;
      } catch (ex) {
        this.patron.branch = '';
        this.newHomeBranch = '';
        console.log('set as home: '+ this.patron.homeBranchId);
      }
    }
    if (this.selectTab && this.selectTab === 'bookshelf') {
      setTimeout(()=>this.view = 'shelves',0);
    }
    this.loadPage = true;
    this.getBookInformation(this.patron.checkouts, 'checkouts');
    this.getBookInformation(this.patron.holds, 'holds');
    this.patronProvider.getRegisteredEvents(this.patron.barcode).then((res) => {
      this.registeredEvents.allEvents = res;
      if (res) {
        res.forEach((event) => {
          if (moment(event.eventStart).isBefore(moment())) {
            this.registeredEvents.pastEvents.push(event);
          } else {
            this.registeredEvents.currentEvents.push(event);
          }
        });
      }
    });
    if (!this.bookingsReceived) {
      this.patronProvider.getRoomBookings(this.patron.barcode).then((res) => {
        this.bookingsArray.allBookings = res || [];
        this.bookingsReceived = true;
        this.bookingsArray.pastBookings = [];
        this.bookingsArray.currentBookings = [];
        this.bookingsArray.allBookings.forEach((booking) => {
          if (moment(booking.startTime).isBefore(moment())) {
            booking.showCancel = false;
            this.bookingsArray.pastBookings.push(booking);
            return booking;
          } else {
            this.bookingsArray.currentBookings.push(booking);
            return booking;
          }
        });
      });
    }
    this.getInterestedEvents();
    // console.log(this.state)
    this.patronProvider.getCheckouts(this.patron.barcode).then( (res) => {
      this.ilsCheckoutsLoaded = true
      this.checkoutsLoaded = this.digitalCheckoutsLoaded;
      this.allCheckouts = this.allCheckouts.concat(res);
      this.filteredCheckouts = this.allCheckouts;
      this.currentCheckoutType = 'all';
      this.getBookTypes('checkouts');
    });
    this.digitalProdivder.getDigitalCheckouts(this.patron.barcode, this.patron.pin).then( (res) => {
      this.digitalCheckoutsLoaded = true;
      this.checkoutsLoaded = this.ilsCheckoutsLoaded;
      this.allCheckouts = this.allCheckouts.concat(res);
      this.filteredCheckouts = this.allCheckouts;
    });
    this.patronProvider.getHolds(this.patron.barcode).then((res) => {
      this.ilsHoldsLoaded = true;
      this.holdsLoaded = this.digitalHoldsLoaded;
      res.forEach( h => { if(h.isReady) this.holdReady++; });
      this.allHolds = this.allHolds.concat(res);
      this.filteredHolds = this.allHolds;
      this.currentHoldsType = 'all';
      this.getBookTypes('holds');
    });
    this.digitalProdivder.getDigitalHolds(this.patron.barcode, this.patron.pin).then( (res) => {
      this.digitalHoldsLoaded = true;
      this.holdsLoaded = this.ilsHoldsLoaded;
      res.forEach( h => { if(h.isReady) this.holdReady++; });
      this.allHolds = this.allHolds.concat(res);
      this.filteredHolds = this.allHolds;
    });
    this.patronProvider.getFines(this.patron.barcode).then((res) => {
      this.fees = res || [];

      // TEST FINES DATA FOR ROAM
    // if (this.patron.barcode === '21268023168444') {

    //   this.fees.push({amount: 1,
    //     amountPaid: null,
    //     bib: {
    //       author: "Todd, Charles,",
    //       authors: ["Todd, Charles,"],
    //       available: null,
    //       averageRating: null,
    //       format: "Eaudiobook",
    //       id: "1046683",
    //       ids: [],
    //       imageLinks: null,
    //       isbns: ["9780062802330", "006280233X"],
    //       language: null,
    //       notes: [],
    //       pageCount: null,
    //       previewLink: "http://link.overdrive.com/?websiteID=150&titleID=3280512",
    //       publishYear: 2018,
    //       publisher: null,
    //       ratingsCount: null,
    //       readingModes: null,
    //       series: ["An Inspector Ian Rutledge mystery ;"],
    //       subjects: [],
    //       summaries: null,
    //       title: "The gate keeper",
    //       upcs: [],
    //     },
    //     description: "Printing Fee",
    //     id: 9821423,
    //     willPay: false})

    //     this.fees.push({amount: 12,
    //       amountPaid: null,
    //       bib: {
    //         author: "Todd, Charles,",
    //         authors: ["Todd, Charles,"],
    //         available: null,
    //         averageRating: null,
    //         format: "Eaudiobook",
    //         id: "1046683",
    //         ids: [],
    //         imageLinks: null,
    //         isbns: ["9780062802330", "006280233X"],
    //         language: null,
    //         notes: [],
    //         pageCount: null,
    //         previewLink: "http://link.overdrive.com/?websiteID=150&titleID=3280512",
    //         publishYear: 2018,
    //         publisher: null,
    //         ratingsCount: null,
    //         readingModes: null,
    //         series: ["An Inspector Ian Rutledge mystery ;"],
    //         subjects: [],
    //         summaries: null,
    //         title: "The gate keeper",
    //         upcs: [],
    //       },
    //       description: "Printing Fee",
    //       id: 9821493,
    //       willPay: false})

    //       this.fees.push({amount: 6,
    //         amountPaid: null,
    //         bib: {
    //           author: "Todd, Charles,",
    //           authors: ["Todd, Charles,"],
    //           available: null,
    //           averageRating: null,
    //           format: "Eaudiobook",
    //           id: "1046683",
    //           ids: [],
    //           imageLinks: null,
    //           isbns: ["9780062802330", "006280233X"],
    //           language: null,
    //           notes: [],
    //           pageCount: null,
    //           previewLink: "http://link.overdrive.com/?websiteID=150&titleID=3280512",
    //           publishYear: 2018,
    //           publisher: null,
    //           ratingsCount: null,
    //           readingModes: null,
    //           series: ["An Inspector Ian Rutledge mystery ;"],
    //           subjects: [],
    //           summaries: null,
    //           title: "The gate keeper",
    //           upcs: [],
    //         },
    //         description: "Printing Fee",
    //         id: 9828273,
    //         willPay: false})

    //       }

      this.fees.forEach(fee=>{
        fee.willPay = false;
      });
      if (res && res.length > 0){
        this.totalFees = res.reduce((sum, fine)=>{
          return sum + fine.amount;
        }, 0);
      };
    }).catch(err => console.log(err));
    if (this.loader) {
      this.loader.dismiss().catch(err=>{});
    }
  }

  refreshCheckouts(){
    this.checkoutsLoaded = false;
    this.patronProvider.getCheckouts(this.patron.barcode).then((res) => {
      this.digitalProdivder.getDigitalCheckouts(this.patron.barcode, this.patron.pin).then((checkouts)=> {
        this.checkoutsLoaded = true;
        res = res.concat(checkouts);
        this.allCheckouts = res || [];
        // console.log(this.allCheckouts, checkouts);
        this.filteredCheckouts = res || [];
        this.currentCheckoutType = 'all';
        this.getBookTypes('checkouts');
      });
    });
  }

  refreshHolds(){
    this.allHolds = [];
    this.holdReady = 0;
    this.holdsLoaded, this.ilsHoldsLoaded, this.digitalHoldsLoaded = false;
    this.patronProvider.getHolds(this.patron.barcode).then( (res) => {
      this.ilsHoldsLoaded = true;
      this.holdsLoaded = this.digitalHoldsLoaded;
      res.forEach( h => { if(h.isReady) this.holdReady++; });
      this.allHolds = this.allHolds.concat(res);
      this.filteredHolds = this.allHolds;
      this.currentHoldsType = 'all';
      this.getBookTypes('holds');
    });
    this.digitalProdivder.getDigitalHolds(this.patron.barcode, this.patron.pin).then( (res) => {
      this.digitalHoldsLoaded = true;
      this.holdsLoaded = this.ilsHoldsLoaded;
      res.forEach( h => { if(h.isReady) this.holdReady++; });
      this.allHolds = this.allHolds.concat(res);
      this.filteredHolds = this.allHolds;
    });
  }

  getInterestedEvents() {
    this.listProvider.getList('events').then((res) =>{
      this.interestedEvents = res;
      this.interestedCurrentEvents = res.filter( event => moment().isBefore(event.value.eventEnd) );
      this.interestedPastEvents = res.filter( event => moment().isAfter(event.value.eventEnd) );
    });
  }

  updateFeeTotal(event, fee){
    if (event.checked){
			this.feesCountToPay++;
      this.feesAmountToPay += fee.amount;
    } else {
			this.feesCountToPay--;
      this.feesAmountToPay -= fee.amount;
    };
  }

  dataChange(event){
    this.patronInfoChanged = true;
  }

  changePatronInfo(save){
    if (!save) this.initializeMyAccount(this.state.patron, true);
  }

  submitPinChange() {
    this.saving = true;
    let loader = this.loading.create({
      content: 'Saving pin'
    });
    loader.present();
    if (this.previousPin !== this.patron.pin) {
      this.patronProvider.updatePatronPin(this.patron).then((res)=>{
        loader.dismiss();
        if (res.status) {
          this.toast.triggerToast('Changes saved','','success', 3000);
          this.previousPin = "";
          this.patron.pin = "";
          this.pinEditMode = false;
        } else {
          this.toast.triggerToast(res.message, 'Changes Failed','warning', 3000);
        }

        this.saving = false;
      });
    } else {
      loader.dismiss();
      this.previousPin = "";
      this.pinEditMode = false;
      this.saving = false;
    }
  }

  getBookTypes(listType) {
    if (listType === 'checkouts') {
      this.allCheckouts.forEach(book => {
        let safe = !!book;
        this.checkoutTypes.forEach(type => {
          if (book.bib && type === book.bib.format) {
            safe = false;
          } else if (!book.bib) {
            safe = false;
          }
        });
        if (safe) {
          this.checkoutTypes.push(book.bib.format);
        }
      });
    } else if (listType === 'holds') {
      this.allHolds.forEach(book => {
        let safe = !!book;
        this.holdsTypes.forEach(type => {
          if (type === book.bib.format) {
            safe = false;
          }
        });
        if (safe) {
          this.holdsTypes.push(book.bib.format);
        }
      });
    }
  }

  filterByCheckoutType(type) {
    this.currentCheckoutType = type;
    if (type === 'all') {
      this.filteredCheckouts = this.allCheckouts;
      return;
    }
    this.filteredCheckouts = [];
    this.allCheckouts.forEach((checkout) => {
      if (checkout.bib.format === type) {
        this.filteredCheckouts.push(checkout);
      }
    })
  }

  filterByHoldsType(type) {
    this.currentHoldsType = type;
    if (type === 'all') {
      this.filteredHolds = this.allHolds;
      return;
    }
    this.filteredHolds = [];
    this.allHolds.forEach((hold) => {
      if (hold.bib.format === type) {
        this.filteredHolds.push(hold);
      }
    })
  }

  dismiss() {
    this.view.dismiss().catch(err=>{});
  }

  getBookInformation(bookList, list){
    // let loader = this.loading.create({
    //   content: 'Getting checkout and holds info...',
    // });
    // loader.present();
    if (!bookList) {
      return;
    }
    bookList.forEach((book, index) => {
      if (book.bib && !book.bib.src) {
        this.ilsProvider.getBibDetailsFromId(book.bib.id).then(res =>{
			if(!res)return;
          if(res.upcs.length>0){
            book.isbnObj = {number: res.upcs[0], type: 'upc'};
          }else if(res.isbns.length>0){
            book.isbnObj = {number: res.isbns[0], type: 'isbn'};
          }
          book.bib = res;
          if (list === 'checkouts'){
            this.allCheckouts.push(book);
            // console.log(book);
            // console.log(book)
          } else if (list === 'holds'){
            this.allHolds.push(book);
          }
        });
      } else if (book.bib && book.bib.src){
        if (list === 'checkouts'){
          this.allCheckouts.push(book);
          // console.log(book);
          // console.log(book)
        } else if (list === 'holds'){
          this.allHolds.push(book);
        }
      }
        // if (index >= this.patron.checkouts.length - 1){
      //   loader.dismiss();
      // }
    });
  }

  goToLibraryCard(patron){
    if (this.state.staff) {
      this.navCtrl.push(CoLibraryCardPage, {barcode: this.patron.barcode});
    } else {
      this.navCtrl.push(CoLibraryCardPage);
    }
  }

  openFeesModal(patron, fines){
    let modal = this.modalCtrl.create(CoPatronFeesPage, { fines: fines, patron: patron, total: this.feesAmountToPay }, {cssClass: "full-screen-modal"});
    modal.present();

    modal.onDidDismiss((p) => {
			if (p) {
				this.fees.forEach(f => {
					if (f.willPay) f.willPay = false;
				});
			};
		});
  }


  checkOutItem(book) {
    let loader = this.loading.create({content: 'Checking out item...'});
    switch(book.bib.source.toLowerCase()) {
      case 'overdrive':
        this.digitalProdivder.checkoutOverdriveItem(book.bib.id, this.patron.barcode, this.patron.pin).then( (res) => {
          if(res && res.status) {
            this.toast.showAlert('', 'Your item has been checked out and can be accessed from your account.', 'success', 5000);
          } else {
            this.toast.showAlert('', res && res.message ? res.message : 'Sorry, there was a problem checking out this item.', '', 5000);
          }
          loader.dismiss();
        });
    }
  }

  renewBook(book){
    if (book.isRenewed){
      this.toast.triggerToast('You have renewed this item already!', '');
      return;
    } else {
      // book.isRenewed = true;
      // book.newDate = moment(book.dueDate).add(1, 'week').format("YYYY-MM-DD");
    }
    let loader = this.loading.create({
      content: 'Renewing Item'
    });
    loader.present();
    this.allCheckouts.forEach(checkout => {
      if (checkout.id === book.id) {
        this.ilsProvider.renewBook(checkout.id, this.patron.barcode, this.state.staff ? '' : this.patron.pin).then((res) => {
          if (res.status) {
            book.isRenewed = true;
            book.dueDate = res.dueDate;
            book.newDate = res.dueDate;
            this.toast.showAlert('','Item renewed successfully!',"success");
            loader.dismiss().catch(err=>{});
          } else {
            const message = res.message ? `: ${res.message}` : '';
            this.toast.showAlert('',`Failed to renew item${message}`,'warning');
            loader.dismiss().catch(err=>{});
          }
        });
        return checkout;
      }
    });
  }

  returnItem(item){
    let loader = this.loading.create({content: 'Checking in item...'});
    loader.present();
    this.digitalProdivder.checkInDigitalItem(item.bib.source, item.bib, this.patron.barcode, this.patron.pin).then(res=>{
      loader.dismiss().catch(err=>{});
      if (res && res.status){
        this.toast.showAlert('','Item returned successfully!','success', 5000);
        this.refreshCheckouts();
      } else {
        this.toast.showAlert('',res.message||'Failed to return item','', 5000);
      }
    });
  }

  cancelHold(item){
    let loader = this.loading.create({content: 'Cancelling hold...'});
    loader.present();
    if(item.bib && item.bib.source && item.bib.source === 'overdrive') {
      this.digitalProdivder.cancelOverdriveHold(item.bib.id, this.patron.barcode, this.patron.pin).then( (res) => {
        loader.dismiss().catch(err=>{});
        if (res && res.status){
          this.toast.showAlert('','Hold Cancelled!','success', 5000);
          this.refreshHolds();
        } else {
          this.toast.showAlert('',res.message||'Failed to cancel item','', 5000);
        }
      });
    } else {
      this.ilsProvider.cancelHold(this.patron.barcode, item.id, this.patron.pin).then(res=>{
        loader.dismiss().catch(err=>{});
        if (res && res.status){
          this.toast.showAlert('','Hold Cancelled!','success', 5000);
          this.refreshHolds();
        } else {
          this.toast.showAlert('',res.message||'Failed to cancel item','', 5000);
        }
      });
    }
  }

  freezeOrUnfreezeHold(item){
    if (item.frozen) this.unfreezeHold(item);
    else this.freezeHold(item);
  }

  freezeHold(item) {
    let loader = this.loading.create({content: 'Freezing hold...'});
    loader.present();
    if(item.bib && item.bib.source && item.bib.source === 'overdrive') {
      this.digitalProdivder.freezeOverdriveHold(item.bib.id, this.patron.barcode, this.patron.pin, this.patron.email).then( (res) => {
        loader.dismiss().catch(err=>{});
        if(res && res.status) {
          this.toast.showAlert('', 'Hold Frozen!', 'success', 5000);
          this.refreshHolds();
        } else {
          this.toast.showAlert('', res && res.message ? res.message : 'Failed to freeze item', '', 5000);
        }
      });
    } else {
      this.ilsProvider.freezeHold(this.patron.barcode, this.patron.pin, item.id).then(res=>{
        loader.dismiss().catch(err=>{});
        if (res && res.status){
          this.toast.showAlert('','Hold Frozen!','success', 5000);
          this.refreshHolds();
        } else {
          this.toast.showAlert('', res && res.message ? res.message : 'Failed to freeze item', '', 5000);
        }
      });
    }
  }

  unfreezeHold(item) {
    let loader = this.loading.create({content: 'Freezing hold...'});
    loader.present();
    if(item.bib && item.bib.source && item.bib.source === 'overdrive') {
      this.digitalProdivder.unfreezeOverdriveHold(item.bib.id, this.patron.barcode, this.patron.pin).then( (res) => {
        loader.dismiss().catch(err=>{});
        if(res && res.status) {
          this.toast.showAlert('', 'Hold Unfrozen!', 'success', 5000);
          this.refreshHolds();
        } else {
          this.toast.showAlert('', res && res.message ? res.message : 'Failed to unfreeze item', '', 5000);
        }
      });
    } else {
      this.ilsProvider.unfreezeHold(this.patron.barcode, this.patron.pin, item.id).then(res=>{
        loader.dismiss().catch(err=>{});
        if (res && res.status){
          this.toast.showAlert('','Hold Unfrozen!','success', 5000);
          this.refreshHolds();
        } else {
          this.toast.showAlert('', res && res.message ? res.message : 'Failed to unfreeze item', '', 5000);
        }
      });
    }
  }

  readNow(item){
    this.digitalProdivder.readNow(item.bib.source, item.bib, this.patron.barcode, this.patron.pin);
  }

  openBookDetail(book){
    if(book.bib.source && (book.bib.source === 'hoopla' || book.bib.source === 'overdrive')) {
      this.currentModal = this.bib.showItemFromBibId(book.bib);
    } else if(book.bib.id) {
      this.currentModal = this.bib.showItemFromBibId(book.bib.id);
    } else if(book.bib.isbns.length > 0) {
      this.currentModal = this.bib.showItemFromISBN(book.bib.isbns[0]);
    } else if(book.bib.upcs.length > 0) {
      this.currentModal = this.bib.showItemFromUPC(book.bib.isbns[0]);
    } else {
      this.toast.showAlert('', 'Sorry, cannot retrieve book info');
    }
  }

  goToLocation(book){
    this.searchForBranch(book).then(res =>{
      this.config.load(this.state.appId).then(cfg => {
        this.navCtrl.push(CoLocationComponent, { location: res.id, showNavbar: true });
      });
    })

  }

  async searchForBranch(book){
    let allBranches, output;
    this.locationsProvider.getLocations().then(res =>{
      allBranches = res;
      try {
        output = allBranches.find(object => object.name === book.pickupLocation.name);
      } catch (ex) {
        output = false;
      }
    });
    return output
  }

  payFines(){
    this.feesToPay = this.fees.filter(fee=>{
      return fee.willPay;
    });
    this.openFeesModal(this.patron, this.feesToPay);
  }

  enableEditMode() {
    // if (this.editMode) {
    //   return;
    // }
    // let headers = Array.from(document.querySelectorAll('.editHeader'));
    // headers.forEach(header => {
    //   header.classList.toggle('editMode');
    // })
    // this.editMode = true;
    // console.log('edit mode init');
  }

  gotoEditScreen(segment: string) {
    this.navCtrl.push(CoPatronDetailFormPage, { patron: this.patron, segment });
  }
}



// WEBPACK FOOTER //
// ./src/components/co-patron-detail/co-patron-detail.ts